const hasChanges = (state = false, action) => {
  switch (action.type) {
    case "SET_SYSTEM_TRAY_MENU":
    case "PUSH_SYSTEM_TRAY_MENU_ITEM":
    case "SET_MENU_ITEM":
    case "REMOVE_MENU_ITEM":
      return true
    case "CLEAR_CHANGES":
      return false
    default:
      return state
  }
}

export default hasChanges
